import { useEffect } from "preact/hooks";
import { Accordion, Button, DetailLayout, PageHeader, RailPanel, Switch } from "../../../../ui/src/index.ts";
import type { HubSummary } from "../../domain/types.ts";
import { setToursOn, startTour, TOUR_IDS, type TourId } from "../guide-state.ts";
import { tourRoute, useHelpContext } from "../Guide.tsx";
import { FAQ, TOURS } from "../help.tsx";
import { Section } from "../parts.tsx";
import { navigate, type Route } from "../router.ts";
import { useStore } from "../store.ts";

type HelpRoute = Extract<Route, { name: "help" }>;

export function Help({ hub, route }: { hub: HubSummary; route: HelpRoute }) {
  const context = useHelpContext(hub);
  const on = useStore((s) => s.toursOn);
  const seen = useStore((s) => s.seenTours);
  useEffect(() => { if (route.item) document.getElementById(route.item)?.scrollIntoView({ block: "start" }); }, [route.item]);
  const start = (id: TourId) => { navigate(tourRoute(id, context.hub)); startTour(id); };

  return <>
    <PageHeader title={<>Learn how Studio <strong>works</strong></>} description="Common questions about Curator Studio and the Exchange, and short walkthroughs of the main pages." />
    <DetailLayout rail={<>
      <RailPanel title="Walkthroughs">
        <ul class="st-walkthroughs">{TOUR_IDS.map((id) => <li key={id}>
          <div><strong>{TOURS[id].title}</strong><span>{TOURS[id].about}</span></div>
          <Button size="sm" onClick={() => start(id)}>{seen.includes(id) ? "Again" : "Start"}</Button>
        </li>)}</ul>
        <Switch label="Guided walkthroughs" hint="Offer one on pages you haven't toured" checked={on} onChange={setToursOn} />
      </RailPanel>
    </>}>
      {FAQ.map((group) => <Section key={group.topic} title={group.topic}>
        <Accordion label={group.topic} open={route.item} items={group.items.map((item) => ({ id: item.id, title: item.question, body: item.answer(context) }))} />
      </Section>)}
    </DetailLayout>
  </>;
}
